import React,{useState} from 'react'

export function Textform(props) {
  const clk=()=>{
    console.log("clicked");
    let newtext=text.toUpperCase();
    setText(newtext)
  }
  const change =(event)=>{
    setText(event.target.value)
  }
  const tolower=()=>{
    let newlower=text.toLowerCase()
    setText(newlower)
  }
  const smpltxt =()=>{
    let newsmpl=("You Can Enter Your Text Here To Perform an Operation")
    setText(newsmpl)
  }
  const clrtxt =()=>{
    let clr="";
    setText(clr)
    props.all("You have Cleared The Text","Success")
  }
  const[text,setText]=useState("")
  let handlecopy=()=>{
    var text=document.getElementById("txtvl");
    text.select();
    navigator.clipboard.writeText(text.value)
    document.getSelection().removeAllRanges()
  }
  return (

   <>
    <div className='container' >
      <p>{props.title}</p>
      <input type='text'value={text} onChange={change} className='inn' id='txtvl'style={{backgroundColor:props.mode==='dark'?'light':'dark'}}></input><br></br>
      <button disabled={text.length===0} onClick={clk}className='btn btn-primary my-1' >Change text to uppercase</button>
      <br/><button disabled={text.length===0} onClick={tolower} className='btn btn-primary my-1' >Convert to lowercase</button> <br/>
      <button disabled={text.length===0} onClick={clrtxt}className='btn btn-primary my-1'>Clear Text</button>
      <br/><button  onClick={smpltxt}className='btn btn-primary my-1'>Sample Text</button>
      <br/>
      <button disabled={text.length===0} onClick={handlecopy}className='btn btn-primary my-1'>Copy Text</button>
    </div>
    <div className='container'>
      <p>{text.length} charecters present into your paragraph</p>
      <p>{text.split(/\s+/).filter((element)=>{return element.length!==0}).length} Words present in the Para</p>
      <p>{0.008*text.split(" ").filter((element)=>{return element.length!==0}).length} minutes need to read the paragraph</p>
      <h2>Priview</h2>
      <p>{text.length>0?text:"Enter something to Priview it"}</p>
    </div>
   </>
  )
}


